import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { isSignInWithEmailLink, signInWithEmailLink } from 'firebase/auth';
import { getFirebaseInstance } from '../firebase/config';

function EmailLinkHandler() {
    const navigate = useNavigate();
    const location = useLocation();
    const [showLoading, setShowLoading] = useState(false);

    useEffect(() => {
        const handleEmailLink = async () => {
            const { auth } = getFirebaseInstance();

            // Verificar si la URL actual es un enlace de autenticación por email
            if (!isSignInWithEmailLink(auth, window.location.href)) {
                return;
            }

            // Mostrar la animación de carga
            setShowLoading(true);

            try {
                // Intentar obtener el email de la URL primero
                const params = new URLSearchParams(location.search);
                const emailFromUrl = params.get('email');

                // Si no está en la URL, intentar obtenerlo del localStorage
                const storedEmail = window.localStorage.getItem('emailForSignIn');

                // Usar el email de la URL o del localStorage
                const emailToUse = emailFromUrl || storedEmail;

                if (!emailToUse) {
                    console.log('No se encontró email en la URL ni en localStorage');
                    setShowLoading(false);
                    navigate('/login', { replace: true });
                    return;
                }

                // Autenticar al usuario
                console.log('Intentando autenticar con email:', emailToUse);
                await signInWithEmailLink(auth, emailToUse, window.location.href);

                // Limpiar el email del localStorage
                window.localStorage.removeItem('emailForSignIn');

                // Detener la animación y navegar al home
                setShowLoading(false);
                // Pequeño delay para asegurar que la animación se detenga
                setTimeout(() => {
                    navigate('/home', { replace: true });
                }, 100);

            } catch (error) {
                console.error('Error durante la autenticación:', error);
                setShowLoading(false);
                navigate('/login', { replace: true });
            }
        };

        handleEmailLink();

        // Cleanup function para asegurar que la animación se detenga
        return () => {
            setShowLoading(false);
        };
    }, [navigate, location]);

    // Siempre renderizar el div del loading, pero controlarlo con CSS
    return (
        <div className={`loading-overlay email-link-overlay ${showLoading ? 'visible' : ''}`}>
            <div className="loading-container">
                <div className="loading-spinner"></div>
                <div className="loading-text">Verificando tu identidad...</div>
            </div>
        </div>
    );
}

export default EmailLinkHandler; 